import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Bolt = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox={props.BgColor ? "0 0 104 104" : "0 0 90 90"}
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={props.size}
            height={props.size}>
            { props.BgColor ?  <rect x="0.5" width="104" height="104" rx="50" fill={props.BgColor}/> : null }
            <path fillRule="evenodd" 
            clipRule="evenodd" 
            d="M54.2773 17.689C55.1121 18.2287 55.3514 19.343 54.8117 20.1778L37.4071 47.1006H62.9C63.5593 47.1006 64.1658 47.461 64.481 48.0401C64.7962 48.6191 64.7696 49.3242 64.4117 49.8778L45.2117 79.5778C44.672 80.4127 43.5577 80.6519 42.7228 80.1122C41.888 79.5725 41.6487 78.4582 42.1884 77.6234L59.593 50.7006H34.1001C33.4408 50.7006 32.8342 50.3402 32.5191 49.7611C32.2039 49.1821 32.2305 48.477 32.5884 47.9234L51.7884 18.2234C52.3281 17.3885 53.4424 17.1493 54.2773 17.689Z" 
            fill={props.color ? props.color: "white"}/>
        </SvgStyled>
    );
};

export default Bolt;
